import { fetchRequest } from 'src/hooks/useAPIRequest'

import { AppCounters } from '../getExpertCounters'

export type SalesCounterModule = 'publishing'

export type SalesCounterItemGroup = 'sales_processes' | 'publications' | 'physical_process'

interface Props {
    module: SalesCounterModule
    itemGroup: SalesCounterItemGroup
}

const getSalesCounters = ({ module, itemGroup }: Props) =>
    fetchRequest<AppCounters[]>(`/sale/meta/counters/${module}?item_groups=${itemGroup}`)

export default getSalesCounters
